"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
require("./carousel-control.css");
var _iconButton = _interopRequireDefault(require("../icon-button"));
var _chevronLeft = _interopRequireDefault(require("../../icons/chevron-left"));
var _chevronRight = _interopRequireDefault(require("../../icons/chevron-right"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var CarouselControl = function CarouselControl(_ref) {
  var activePaginatorClassName = _ref.activePaginatorClassName,
    ariaLabelPrev = _ref.ariaLabelPrev,
    ariaLabelNext = _ref.ariaLabelNext,
    ariaLabelSelected = _ref.ariaLabelSelected,
    totalPages = _ref.totalPages,
    selectedPage = _ref.selectedPage,
    showControlArrows = _ref.showControlArrows,
    handleClick = _ref.handleClick,
    handlePreviousClick = _ref.handlePreviousClick,
    handleNextClick = _ref.handleNextClick,
    className = _ref.className,
    ariaLabelPages = _ref.ariaLabelPages;
  var showPreviousArrow = selectedPage !== 0;
  var showNextArrow = selectedPage !== totalPages - 1;
  var buildCarouselDotAriaLabel = function buildCarouselDotAriaLabel(index) {
    var label = ariaLabelPages(index + 1);
    return selectedPage === index ? "".concat(label, ", ").concat(ariaLabelSelected) : label;
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-center carousel__control ".concat(className ? className : '')
  }, showControlArrows && showPreviousArrow ? /*#__PURE__*/_react["default"].createElement(_iconButton["default"], {
    ariaLabel: ariaLabelPrev,
    className: "carousel__control__arrows",
    onClick: handlePreviousClick,
    path: _chevronLeft["default"],
    size: "30px"
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "carousel__control__arrows"
  }), _toConsumableArray(Array(totalPages).keys()).map(function (i) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      "aria-label": buildCarouselDotAriaLabel(i),
      className: "my4 mx2 carousel__dot ".concat(selectedPage === i ? "".concat(activePaginatorClassName || 'carousel__dot__active', " isActive") : ''),
      key: i,
      onClick: handleClick.bind(null, i)
    });
  }), showControlArrows && showNextArrow ? /*#__PURE__*/_react["default"].createElement(_iconButton["default"], {
    ariaLabel: ariaLabelNext,
    className: "carousel__control__arrows",
    onClick: handleNextClick,
    path: _chevronRight["default"],
    size: "30px"
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "carousel__control__arrows"
  }));
};
CarouselControl.propTypes = process.env.NODE_ENV !== "production" ? {
  ariaLabelPages: _propTypes["default"].func.isRequired,
  className: _propTypes["default"].string,
  handleClick: _propTypes["default"].func,
  selectedPage: _propTypes["default"].number,
  showControlArrows: _propTypes["default"].bool,
  totalPages: _propTypes["default"].number
} : {};
CarouselControl.defaultProps = {
  ariaLabelPrev: '',
  ariaLabelNext: '',
  ariaLabelPages: function ariaLabelPages(page) {
    return "".concat(page);
  },
  ariaLabelSelected: 'selected',
  handleClick: function handleClick() {},
  selectedPage: 0,
  totalPages: 1,
  showControlArrows: false
};
var _default = exports["default"] = CarouselControl;